export const UseUserLevel = (id) => {
  let level = '';
  switch (id) {
    case 1:
      level = 'As_Pricing_Plan1';
      break;
    case 2:
      level = 'As_Pricing_Plan2';
      break;
    case 3:
      level = 'As_Pricing_Plan3';
      break;
    default:
      break;
  }
  return level;
};
